import { useState, useEffect, useRef, useMemo } from 'react'
import { useLazyGetBrandsQuery } from "context/utils/brandsApiSlice";

import { Controller } from "react-hook-form";
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import MDInput from 'dashboard/components/MDInput';
import MDBox from "dashboard/components/MDBox"
import Chip from '@mui/material/Chip';
import useAlert from 'hooks/useAlert';
import useSearch from "hooks/useSearch";

/* eslint-disable */
export const CategorySelect = ({ onChange: ignored, control, fetchData, selected, category,name, required,register, errors, size, helperText}) => {

    const [open, setOpen] = useState(false);
    const [categoriesList, setCategoriesList] = useState([]);
    const categoryRef = useRef(null);
    const [defaultValue, setDefaultValue] = useState(null);
    const {showAlerts} = useAlert();
    const { searchTerm, filterSearch } = useSearch();

    const chatsQuery = useMemo(
      () =>{  
        const filter = Object.fromEntries(Object.entries(searchTerm.filters).filter( item => item[1] !== null && item[1] !== undefined && item[1] !== '' && item[1].length !== 0)); 
        return ({
          parent: name === "parent" ? true : false,
          filters: JSON.stringify(filter),
        })},
      [searchTerm.filters, searchTerm.page]
    );

    const {
        data: categories = [],
        isError,
        isSuccess,
        isLoading,
        isFetching,
        error : errorTxt
      } = fetchData( chatsQuery, {
          refetchOnMountOrArgChange: true,
          // skip : categoriesList?.length !== 0 
      })
    
    useEffect( async () => {
      let active = true;
      if ( !open && !active) {
        return undefined;
      }
  
      if ( active && isSuccess) { 
          categoryRef.current = category?.id;
          let categoryList = Object.values(categories.entities);
          categoryList = (name === "parent" && category) ?  categoryList.filter( ele => !ele.category.startsWith(category.category) ) : categoryList;
          setCategoriesList(categoryList);    
      }
      isError && showAlerts({code:"error", msg : `Unable to load the categories list !`, type : "toast"});
      return () => {
        active = false;
      };
    }, [isLoading, isFetching, category]);
    
    useEffect(() => {
      if(selected){
        setDefaultValue(selected);
      }
    }, [selected]);

    let typingTimeout;

    const inputFieldSearch = event => {
      clearTimeout(typingTimeout);
      typingTimeout = setTimeout(()=> {
        filterSearch({filters : {...searchTerm.filters, [event.target.name] : event.target.value}});
      }, 500);
    }
    
    return (
      <>
      <Controller render={({ field: { onChange, props } }) => (
        <Autocomplete fullWidth
          noOptionsText={'Rien ne correspond à votre terme de recherche'}
          id="asynchronous-cat"
          {...register(`${name}`, { required: required ?   helperText : false , validate : required ? value => value !== null ? Object.keys(value).length !== 0 : value !== null : null })}
          autoComplete={false}
          open={open}
          onOpen={() => {
            setOpen(true);
          }}
          onClose={() => {
            setOpen(false);
          }}
          value={defaultValue}
          onChange={(event, value, reason, details) => {
            setDefaultValue(value);
            onChange(value)
          }}
          {...props}
          isOptionEqualToValue={(option, value) => option.id ===  defaultValue?.id}
          getOptionLabel={(option) =>  option.name }
          size={size}
          options={categoriesList}
          loading={open  && ( isLoading || isFetching)}
          renderInput={(params) => (
            <MDInput
              {...params}
              label="Imbriquer sous"
              name="name"
              onChange={inputFieldSearch}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {open  && ( isLoading || isFetching) ? <CircularProgress color="inherit" size={20} /> : null}
                    {params.InputProps.endAdornment}
                  </>
                ),
                style:{ padding : size === "small" ? "8px":"5px" },
              }}
            />
          )}
          
        />
      )}
      onChange={([, data]) => data}
      defaultValue={defaultValue}
      autoComplete="off"
      name={name}
      control={control}
      />
       {Boolean(errors[name]) && <p className="MuiFormHelperText-root MuiFormHelperText-sizeSmall MuiFormHelperText-contained Mui-required css-f8sbie-MuiFormHelperText-root">{helperText}</p>}
    </>
    );
}

export const DefaultCategorySelect = ({ onChange,fetchData, selected,name, id, size, label}) => {

  const [open, setOpen] = useState(false);
  const [categoriesList, setCategoriesList] = useState([]);
  const [defaultValue, setDefaultValue] = useState(null);
  const { searchTerm, filterSearch } = useSearch();
  const {showAlerts} = useAlert();
  const chatsQuery = useMemo(
    () =>{  
      const filter = Object.fromEntries(Object.entries(searchTerm.filters).filter( item => item[1] !== null && item[1] !== undefined && item[1] !== '' && item[1].length !== 0)); 
      return ({
        parent: name === "parent" ? true : false,
        filters: JSON.stringify(filter),
      })},
    [searchTerm.filters, searchTerm.page]
  );

  const {
      data: categories = [],
      isError,
      isSuccess,
      isLoading,
      isFetching,
      error : errorTxt
    } = fetchData( chatsQuery, {
        refetchOnMountOrArgChange: true,
        // skip : categoriesList?.length !== 0 
    })
  
  useEffect( async () => {
    let active = true;
    if ( !open && !active) {
      return undefined;
    }

    if ( active && isSuccess) { 
        let categoryList = Object.values(categories.entities);
        setCategoriesList(categoryList.map(item=>({id:item.id,name:item.name})));    
    }
    isError && showAlerts({code:"error", msg : `Unable to load the categories list !`, type : "toast"});
    return () => {
      active = false;
    };
  }, [isLoading, isFetching]);
  
  useEffect(() => {
    if(selected){
      setDefaultValue(selected);
    }
  }, [selected]);

  let typingTimeout;

  const inputFieldSearch = event => {
    clearTimeout(typingTimeout);
    typingTimeout = setTimeout(()=> {
      filterSearch({filters : {...searchTerm.filters, [event.target.name] : event.target.value}});
    }, 500);
  }
  
  return (
    
      <Autocomplete fullWidth sx={{minWidth : 150}}
        noOptionsText={'Rien ne correspond à votre terme de recherche'}
        id="asynchronous-categories"
        autoComplete={false}
        open={open}
        onOpen={() => {
          setOpen(true);
        }}
        onClose={() => {
          setOpen(false);
        }}
        value={defaultValue}
        onChange={(event, value, reason, details) => {
          setDefaultValue(value);
          onChange(id,value);
        }}
        isOptionEqualToValue={(option, value) => option.id ===  defaultValue?.id}
        getOptionLabel={(option) =>  option.name }
        size={size}
        options={categoriesList}
        loading={open  && ( isLoading || isFetching)}
        renderInput={(params) => (
          <MDInput
            {...params}
            label={label}
            name="name"
            onChange={inputFieldSearch}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {open  && ( isLoading || isFetching) ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </>
              ),
              style:{ padding : size === "small" ? "8px":"5px" },
            }}
          />
        )}
        
      />
  );
}

/* eslint-disable */
export const BrandSelect = ({ onChange: ignored, control, selected, register, domaine }) => {

  const [open, setOpen] = useState(false);
  const {showAlerts} = useAlert();
  const [fetchBrands,{isLoading}] = useLazyGetBrandsQuery();
  const [brandsList, setBrandsList] = useState([]);

  const [defaultValue, setDefaultValue] = useState(null);
  const domainRef = useRef(null);
  const loading = open && domaine !== domainRef?.current ;

  const getBrands = async (domaine, page) => {
   const brands = await fetchBrands(domaine, page);
    if(brands.status === "success"){
      domainRef.current = domaine;
       showAlerts({code:"info", msg : "Brands list loaded successfully ! ", type : "toast"});
       setBrandsList(Object.values(brands.entities));
    }else if(brandStatut === "failed"){
      showAlerts({code:"warning", msg : `Unable to load the brands list ! ${brandError}`, type : "toast"});
    }
  }

  useEffect( async () => {
    let active = true;
    if (!loading) {
      return undefined;
    }

    if ( active ) {    
      if (  domaine )  getBrands(domaine,0);
      else showAlerts({code:"warning", msg : `Select a category first`, type : "toast"});
    }
    
    return () => {
      active = false;
    };
  }, [domaine, loading]);
  
  useEffect(() => selected && setDefaultValue(selected), [selected])

  return (
    <>
    <Controller render={({ field: { onChange, props } }) => (
      <Autocomplete fullWidth
        id="asynchronous-cat"
        noOptionsText={'No brand was found for this category'}
        {...register("brand", { required: false })}
        autoComplete={false}
        open={open}
        onOpen={() => {
          setOpen(true);
        }}
        onClose={() => {
          setOpen(false);
        }}
        value={defaultValue}
        onChange={(event, value, reason, details) => {
          setDefaultValue(value);
          onChange(value)
        }}
        {...props}
        isOptionEqualToValue={(option, value) => option.id ===  value.id}
        getOptionLabel={(option) =>  option.name }
        size="medium"
        options={brandList}
        loading={loading}
        renderOption={(props, option) => (
          <MDBox component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
            <img
              loading="lazy"
              width="40"
              src={`${process.env.REACT_APP_PUBLIC_URL}/${option.logo}`}
              srcSet={`${process.env.REACT_APP_PUBLIC_URL}/${option.logo}`}
              alt={option.name}
              style={{objectFit:'cover'}}
            />
            {option.name} 
          </MDBox>
        )}
        renderInput={(params) => (
          <MDInput
            {...params}
            label="Select a Brand"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </>
              ),
              style:{ padding : "5px" },
            }}
          />
        )}
        
      />
    )}
    onChange={([, data]) => data}
    defaultValue={defaultValue}
    autoComplete="off"
    name="brand"
    control={control}
    />
  </>
  );
}
export const SelectTags =  ({ onChange: ignored, control, selected, register, helperText, errors}) =>{

  const [defaultValue, setDefaultValue] = useState([]);
  const tags = ["hamza", "mouh","abdellah"]
  useEffect(() =>{
    if(selected){
      setDefaultValue( selected );
    }
    
  } , [selected])

  return (
    <>
    <Controller render={({ field: { onChange, props } }) => (
      <Autocomplete  
        id="country-select-demo"
        {...register("tags", { required: helperText})}
        options={tags}
        freeSolo
        multiple
        value={defaultValue}
        isOptionEqualToValue={(option, value) => option === value}
        getOptionLabel={ option =>  option || defaultValue }
        onChange={(event, value, reason, details) => {
          setDefaultValue(value);
          onChange(value)
        }}
        {...props}
        size="medium"
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip size="medium"  variant="outlined" label={option} {...getTagProps({ index })} />
          ))
        }
        renderInput={(params, data) => ( 
              <TextField
                {...params}
                label="Tags"
                autoComplete='off'
                inputProps={{
                  ...params.inputProps,
                  autoComplete: 'off',
                  form: {
                    autoComplete: 'off',
                  },
                }}
                
                />
            )}
      />
      )}
      onChange={([, data]) => data}
      defaultValue={defaultValue}
      autoComplete="off"
      name="tags"
      control={control}
    />
    {Boolean(errors.tags) && <p className="MuiFormHelperText-root MuiFormHelperText-sizeMedium MuiFormHelperText-contained Mui-required css-o1ds8i-MuiFormHelperText-root">{helperText}</p>}
    </>
  );
}
